module.exports = __webpack_public_path__ + "media/images/smart_phone/topic_1-816a9b9972382e9399930f781f2caddd.png";